module.exports = require("styletron-react");


//////////////////
// WEBPACK FOOTER
// external "styletron-react"
// module id = 0
// module chunks = 0